<template>
    <div class="main-content">
        <div class="page-header">
            <h3 class="page-title">Bancos</h3>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Ajustes</a></li>
                <li class="breadcrumb-item active">Bancos</li>
            </ol>
        </div>
        <div class="card">
            <div class="card-header">
                <button type="button" @click="openModal('register', '')" class="btn btn-theme">Nuevo</button>
            </div>
            <div class="card-body">
                <div class="form-group row">
                    <div class="col-md-6">
                        <div class="input-group">
                            <input type="text" v-model="search" @keyup="fetchData(1,search,critery)"
                                class="form-control" placeholder="Ingrese el nombre del banco">
                            <button type="submit" @click="fetchData(1,search,critery)" class="btn btn-theme"><i
                                    class="icon-fa icon-fa-search"></i> Buscar</button>
                        </div>
                    </div>
                </div>
                <table class="table table-responsive">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Fecha de registro</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="Bank in Banks" :key="Bank.id">
                            <td v-text="Bank.name"></td>
                            <td v-text="Bank.created_at"></td>
                            <td>
                                <span class="btn btn-success btn-sm">Activo</span>
                            </td>
                            <td>
                                <template>
                                    <div class="table__actions">
                                        <!-- Preguntar si se deja editar y desactivar escrito o solo los iconos -->
                                        <button :href="`#${Bank.name}`" class="btn btn-danger"
                                            @click="openModal('delete',Bank)"><i class="icon-fa icon-fa-trash" />
                                            Eliminar </button>
                                    </div>
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!--Paginación de tabla-->
                <div class="card">
                    <div class="card-body">
                        <ul class="pagination pagination-primary m-b-0">
                            <li class="page-item" v-if="pagination.current_page > 1">
                                <a class="page-link" href="#"
                                    @click.prevent="changePage(pagination.current_page - 1, search, critery)"><i
                                        class="icon-fa icon-fa-angle-left"></i></a>
                            </li>
                            <li class="page-item" v-for="page in pagesNumber" :key="page"
                                :class="[page == isActived ? 'active' : '']">
                                <a class="page-link" href="#" @click.prevent="changePage(page, search, critery)"
                                    v-text="page"></a>
                            </li>
                            <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                <a class="page-link" href="#"
                                    @click.prevent="changePage(pagination.current_page + 1, search, critery)"><i
                                        class="icon-fa icon-fa-angle-right"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- Tabla maquetada por Arturo y Pedro-->
            </div>
        </div>
        <!-- MODALES -->
        <sweet-modal ref="setting_modal" :title="titleModal" hide-close-button blocking>
            <!-- START FORM -->
            <div class="card-body">
                <div class="form-group">
                    <label>Nombre</label>
                    <input :class="{ 'is-invalid': $v.name.$error }" v-model.trim="name" class="form-control"
                        @select="$v.module.$touch()" type="text" />

                    <div v-if="$v.name.$error">
                        <span v-if="!$v.name.required" class="help-block help-block-error">El nombre es requerido</span>
                    </div>
                </div>
            </div>
            <!-- END FORM -->
            <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
            <button slot="button" type="button" class="btn btn-primary ladda-button" data-style="expand-right"
                v-if="typeAction == 1" @click="saveBank()">Guardar</button>
        </sweet-modal>
        <sweet-modal ref="delete_modal" icon="info">
            <p>Esta seguro de editar la venta</p>
            <button slot="button" type="button" class="btn btn-info" @click="$refs.delete_modal.close()">
                Cancelar
            </button>
            <button slot="button" type="button" class="btn btn-success ladda-button" data-style="expand-right"
                v-if="typeAction == 3" @click="deleteBank()">
                Eliminar
            </button>
        </sweet-modal>
    </div>
</template>
<script>
    import { SweetModal, SweetModalTab } from "sweet-modal-vue";
    import { required, sameAs, minLength, between } from "vuelidate/lib/validators";
    import Multiselect from 'vue-multiselect'
    import ladda from "ladda";
    export default {
        components: {
            SweetModal,
            SweetModalTab,
            'multi-select': Multiselect,
        },
        install(Vue, options) {
            Vue.component("SweetModal", SweetModal);
            Vue.component("SweetModalTab", SweetModalTab);
        },
        data() {
            return {
                name: '',
                pagination: [],
                offset: 3,
                critery: 'name',
                search: '',
                titleModal: "",
                typeAction: 1,
                id: 0,
                Banks: [],
            }
        },
        computed: {
            isActived: function () {
                return this.pagination.current_page;
            },
            pagesNumber: function () {
                if (!this.pagination.to) {
                    return [];
                }
                var from = this.pagination.current_page - this.offset;
                if (from < 1) {
                    from = 1;
                }
                var to = from + (this.offset * 2);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }
                var pagesArray = [];
                while (from <= to) {
                    pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            },
        },
        validations: {
            name: {
                required
            }
        },
        methods: {
            changePage(page, search, critery) {
                this.pagination.current_page = page;
                this.fetchData(page, search, critery);
            },
            async fetchData(page, search, critery) {
                let me = this;
                const response = await axios.get(
                    `/api/setting/banks?page=${page}&search=${search}&critery=${critery}`)
                    .then(function (response) {
                        me.Banks = response.data.banks.data;
                        me.pagination = response.data.pagination;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            openModal(accion, data = []) {
                switch (accion) {
                    case "register": {
                        this.$refs.setting_modal.open();
                        this.$v.$reset()
                        this.titleModal = "Nuevo banco";
                        this.name = "";
                        this.typeAction = 1;
                        break;
                    }
                    case "delete": {
                        this.$refs.delete_modal.open();
                        this.titleModal = "Eliminar banco";
                        this.id = data["id"];
                        this.typeAction = 3;
                        break;
                    }
                }
            },
            closeModal() {
                this.$refs.setting_modal.close();
                this.titleModal = "";
                this.fetchData(1, this.search, this.critery);
            },
            saveBank() {
                var l = ladda.create(document.querySelector(".ladda-button"));
                this.$v.$touch();
                let me = this;
                if (this.$v.$invalid) {
                    toastr.error("Revise los campos", "Error");
                } else {
                    l.start();
                    axios
                        .post("/api/setting/banks", {
                            name: this.name
                        })
                        .then(function (response) {
                            toastr.success(response.data.message, "Listo");
                            l.stop();
                            me.closeModal();
                        })
                        .catch(function (error) {
                            l.stop();
                            toastr.error(error.response.data.message, "Error");
                        });
                }
            },
            deleteBank() {
                var l = ladda.create(document.querySelector(".ladda-button"));
                let me = this;
                l.start();
                axios
                    .delete(`/api/setting/banks/${this.id}`)
                    .then(function (response) {
                        toastr.success(response.data.message, "Listo");
                        l.stop();
                        me.$refs.delete_modal.close();
                        me.fetchData(1, me.search, me.critery);
                    })
                    .catch(function (error) {
                        toastr.error(error.response.data.message, "Error");
                        l.stop();
                        me.$refs.delete_modal.close();
                        me.fetchData(1, me.search, me.critery);
                    });
            },
        },
        mounted() {
            this.fetchData(1, this.search, this.critery);
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/admin/settings/Bank.vue